import { Loading } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { Route, Routes } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../state/bound.store'
import { ChatBodyWrapper } from './chatBody/chatBodyWrapper'

export const ChatRouter = () => {
    const { profile } = useBoundStore(
        useShallow((s) => {
            return { profile: s.profile }
        })
    )
    if (!profile)
        return (
            <Stack direction="row" justifyContent="center">
                <Loading />
            </Stack>
        )

    return (
        <Routes>
            <Route key={2} path=":type/:roomID" element={<ChatBodyWrapper />} />
        </Routes>
    )
}
